import { render, staticRenderFns } from "./FormOfTwo.vue?vue&type=template&id=7e54010c&scoped=true&"
import script from "./FormOfTwo.vue?vue&type=script&lang=js&"
export * from "./FormOfTwo.vue?vue&type=script&lang=js&"
import style0 from "./FormOfTwo.vue?vue&type=style&index=0&lang=less&"
import style1 from "./FormOfTwo.vue?vue&type=style&index=1&id=7e54010c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e54010c",
  null
  
)

export default component.exports